import React, { useState } from "react"
import { InfoWindow, Marker } from "@react-google-maps/api";
import { getLocalisedTime } from "../../../Library/datetime";

import "./styles.css";

const stopMarker = require("../../../Assets/images/svgs/pitstop.png");
const STOP_MARKER = { url: stopMarker, scale: 1 };

const PitstopMarker = ({ pitstop }) => {
  const [ showInfoBox, setShowInfoBox ] = useState(false);

  return (
    <Marker zIndex={-1} position={{ lat: pitstop.location.lat, lng: pitstop.location.lng }} icon={{ ...STOP_MARKER, scaledSize: new window.google.maps.Size(16, 24) }} onClick={() => setShowInfoBox(true)}>
      {showInfoBox && (
        <InfoWindow onCloseClick={() => setShowInfoBox(false)} position={{ lat: pitstop.location.lat, lng: pitstop.location.lng }} options={{ pixelOffset: new window.google.maps.Size(0, -5) }}>
          <div className="pitstop-box">
            <header>Stopped {pitstop.entries.length} Time{pitstop.entries.length === 1 ? "" : "s"}</header>
            <label>Stopped Between:</label>

            {pitstop.entries.map((entry, idx) => (
              <div key={idx}>
                <span>{getLocalisedTime(entry.from.ts * 1000, true, true)}</span>
                <span> - </span>
                <span>{getLocalisedTime(entry.to.ts * 1000, true, true)}</span>
              </div>
            ))}
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
}

export default PitstopMarker;
